/* eslint-disable @typescript-eslint/no-var-requires */

import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { IconComponent } from '../../shared/icon/icon.component';
import { DropdownComponent } from '../../shared/dropdown/dropdown.component';
import { DropdownSelectList, Environment, InfoCardList } from '../types';

@Component({
    standalone: true,
    selector: 'global-home-info-card',
    imports: [CommonModule, IconComponent, DropdownComponent],
    templateUrl: './info-card.component.html',
    styleUrls: ['../../styles.scss', './info-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class InfoCardComponent implements OnInit, OnChanges {
    @Input() hasConsumerResearchAccess!: boolean | null;

    @Input() hasAdministrationAccess!: boolean | null;

    @Input() hasSocialMediaAccess!: boolean | null;

    @Input() consumerResearchUrl!: string | null;

    @Input() environment!: Environment | null;

    @Output() trackInfoCardClicks = new EventEmitter();

    hasAccess!: boolean | null;

    helpAndUpdateTemplate!: InfoCardList[];

    ngOnInit() {
        this.hasAccess = this.hasConsumerResearchAccess && this.hasSocialMediaAccess;
        this.updateHelpAndUpdateTemplate();
    }

    ngOnChanges(): void {
        this.hasAccess = this.hasConsumerResearchAccess && this.hasSocialMediaAccess;
        this.updateHelpAndUpdateTemplate();
    }

    badgeSvg = (require('!!raw-loader?!../../assets/icons/badge.svg') as { default: string }).default;

    whatsNewSelectList: DropdownSelectList[] = [
        {
            id: 1,
            name: 'Consumer Research',
            url: 'https://community.brandwatch.com/product-updates',
        },
        {
            id: 2,
            name: 'Social Media Management',
            url: 'https://social-media-management-help.brandwatch.com/hc/en-us/categories/4404905016093-Product-Updates',
        },
    ];

    getProductOptions(infoCardName: string): DropdownSelectList[] {
        if (infoCardName === 'whats-new') {
            return this.whatsNewSelectList;
        }
        return [];
    }

    getWhatsNewUrl(): string {
        if (this.hasConsumerResearchAccess) {
            return 'https://community.brandwatch.com/product-updates';
        }
        return 'https://social-media-management-help.brandwatch.com/hc/en-us/categories/4404905016093-Product-Updates';
    }

    updateHelpAndUpdateTemplate() {
        this.helpAndUpdateTemplate = [
            {
                icon: (require('!!raw-loader?!../../assets/icons/help-center.svg') as { default: string }).default,
                name: 'Help center',
                description: 'Get detailed advice from our FAQs and articles',
                url: 'https://www.brandwatch.com/help-center/',
            },
            {
                icon: (require('!!raw-loader?!../../assets/icons/whats-new.svg') as { default: string }).default,
                name: `What's new`,
                description: 'Explore the latest product features and updates',
                url: this.getWhatsNewUrl(),
                options: this.hasAccess ? this.getProductOptions('whats-new') : [],
            },
            {
                icon: (require('!!raw-loader?!../../assets/icons/webinars.svg') as { default: string }).default,
                name: 'Webinars',
                url: 'https://community.brandwatch.com/events?tab=upcoming',
                description: 'Learn from experts on key topics impacting social',
            },
            {
                icon: (require('!!raw-loader?!../../assets/icons/blog.svg') as { default: string }).default,
                name: 'Blog',
                url: 'https://www.brandwatch.com/blog/',
                description: 'Discover the latest trends, news and insights',
            },
            {
                icon: (require('!!raw-loader?!../../assets/icons/platform-status.svg') as { default: string }).default,
                name: 'Platform Status',
                url: 'https://status.brandwatch.com/',
                description: 'Check the current performance of our products',
            },
        ];
    }

    get adminUrl(): string {
        if (this.environment === Environment.STAGING) {
            return 'https://admin.stage.brandwatch.net';
        } else {
            return 'https://admin.brandwatch.com';
        }
    }

    dispatchTrackEvent(itemClicked: string) {
        this.trackInfoCardClicks.emit(itemClicked);
    }
}
